import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import IosShareIcon from '@mui/icons-material/IosShare';
import { usePWAInstall } from '../../hooks/usePWAInstall';

export const PWAInstallButton: React.FC = () => {
  const { isInstallable, isInstalled, isIOS, install } = usePWAInstall();
  const [showIOSGuide, setShowIOSGuide] = useState(false);

  if (isInstalled) {
    return null;
  }

  if (isInstallable) {
    return (
      <Button
        variant="contained"
        size="small"
        startIcon={<DownloadIcon fontSize="small" />}
        onClick={install}
        sx={{
          bgcolor: '#FF3567',
          color: '#FFFFFF',
          borderRadius: '30px',
          fontSize: '0.78rem',
          fontWeight: 700,
          px: 1.8,
          py: 0.5,
          '&:hover': {
            bgcolor: '#E62053',
          },
        }}
      >
        Installer l'App
      </Button>
    );
  }

  if (isIOS) {
    return (
      <>
        <Button
          variant="outlined"
          size="small"
          startIcon={<IosShareIcon fontSize="small" />}
          onClick={() => setShowIOSGuide(true)}
          sx={{
            borderRadius: '8px',
            fontSize: '0.78rem',
            color: 'text.primary',
            borderColor: 'divider',
          }}
        >
          Installer PWA
        </Button>

        <Dialog open={showIOSGuide} onClose={() => setShowIOSGuide(false)} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ fontWeight: 800 }}>Installer sur iPhone / iPad</DialogTitle>
          <DialogContent>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
              Pour installer NexaCraft AI sur votre écran d’accueil et recevoir les notifications d’appels en direct :
            </Typography>
            <Box component="ol" sx={{ pl: 2, m: 0, '& li': { mb: 1, fontSize: '0.85rem' } }}>
              <li>Touchez le bouton de <strong>Partage</strong> dans Safari.</li>
              <li>Faites défiler vers le bas et sélectionnez <strong>Sur l’écran d’accueil</strong>.</li>
              <li>Touchez <strong>Ajouter</strong> en haut à droite.</li>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowIOSGuide(false)} sx={{ fontWeight: 700 }}>
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  return null;
};
